'use strict';

var asyncToGenerator = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var CONTENT_TYPES = {
    'FORM': 'application/x-www-form-urlencoded',
    'JSON': 'application/json'
};

var FetchError = function (_Error) {
    inherits(FetchError, _Error);

    function FetchError(message) {
        classCallCheck(this, FetchError);

        var _this = possibleConstructorReturn(this, (FetchError.__proto__ || Object.getPrototypeOf(FetchError)).call(this, message));

        _this.name = 'FetchError';
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(_this, _this.constructor);
        } else {
            _this.stack = new Error(message).stack;
        }
        return _this;
    }

    return FetchError;
}(Error);

// Wrapping the core fetch-helper functions in a StateContainer to allow us to manage the authToken and bearerPrefix across invokations without
// needing to redefine them.


var StateContainer = function StateContainer() {
    var _this2 = this;

    classCallCheck(this, StateContainer);

    this.setAuthToken = function (authToken) {
        var isAccountApp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        _this2.authToken = authToken;

        if (isAccountApp) {
            _this2.bearerPrefx = 'Bearer';
        } else {
            _this2.bearerPrefx = 'BEARER';
        }
    };

    this.getAuthToken = function () {
        return _this2.authToken;
    };

    this.checkStatus = function (response) {
        if (response.status < 200 || response.status >= 300) {
            var error = new FetchError(response.statusText);
            error.response = response;
            error.status = response.status;
            throw error;
        }
    };

    this.getDefaultArgsForBody = function (args) {
        return Object.assign({}, {
            method: 'POST',
            contentType: CONTENT_TYPES.FORM
        }, args);
    };

    this.failChecker = function (error) {
        if (error.name === 'FetchError') {
            throw error;
        } else {
            console.error(error.stack);
        }
    };

    this.doDefaultFetch = function () {
        var _ref = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url) {
            var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var urlParts, path, query, fetchArguments, response, responseJson;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!(args.isPublic || _this2.authToken)) {
                                _context.next = 27;
                                break;
                            }

                            urlParts = url.split('?');
                            path = urlParts[0];
                            query = '';


                            if (urlParts.length > 1) {
                                query = '?' + encodeURI(urlParts[1]);
                            }

                            fetchArguments = {};


                            if (args.isSimpleCORS) {
                                fetchArguments.credentials = 'include';
                            } else if (!args.isPublic) {
                                fetchArguments.headers = {
                                    'Authorization': _this2.bearerPrefx + ' ' + _this2.authToken
                                };

                                if (!args.excludeCredentials) {
                                    fetchArguments.credentials = 'include';
                                }
                            }

                            _context.prev = 7;
                            _context.next = 10;
                            return fetch(path + query, fetchArguments);

                        case 10:
                            response = _context.sent;

                            _this2.checkStatus(response);

                            if (!args.skipJSON) {
                                _context.next = 16;
                                break;
                            }

                            return _context.abrupt('return', response);

                        case 16:
                            _context.next = 18;
                            return response.json();

                        case 18:
                            responseJson = _context.sent;
                            return _context.abrupt('return', responseJson);

                        case 20:
                            _context.next = 25;
                            break;

                        case 22:
                            _context.prev = 22;
                            _context.t0 = _context['catch'](7);

                            _this2.failChecker(_context.t0);

                        case 25:
                            _context.next = 28;
                            break;

                        case 27:
                            console.error('Attempted to call doDefaultFetch without first setting the auth token! Be sure to call setAuthToken() first!');

                        case 28:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2, [[7, 22]]);
        }));

        return function (_x3) {
            return _ref.apply(this, arguments);
        };
    }();

    this.doDefaultFetchWithBody = function () {
        var _ref2 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url, args) {
            var fetchArguments, response;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            if (!(args.isPublic || _this2.authToken)) {
                                _context2.next = 23;
                                break;
                            }

                            args = _this2.getDefaultArgsForBody(args);
                            fetchArguments = {
                                method: args.method,
                                headers: {
                                    'Content-Type': args.contentType
                                },
                                body: args.body
                            };


                            if (!args.isPublic) {
                                fetchArguments.headers['Authorization'] = _this2.bearerPrefx + ' ' + _this2.authToken;

                                if (!args.excludeCredentials) {
                                    fetchArguments.credentials = 'include';
                                }
                            }

                            _context2.prev = 4;
                            _context2.next = 7;
                            return fetch(url, fetchArguments);

                        case 7:
                            response = _context2.sent;

                            _this2.checkStatus(response);

                            if (!args.skipJSON) {
                                _context2.next = 13;
                                break;
                            }

                            return _context2.abrupt('return', response);

                        case 13:
                            _context2.next = 15;
                            return response.json();

                        case 15:
                            return _context2.abrupt('return', _context2.sent);

                        case 16:
                            _context2.next = 21;
                            break;

                        case 18:
                            _context2.prev = 18;
                            _context2.t0 = _context2['catch'](4);

                            _this2.failChecker(_context2.t0);

                        case 21:
                            _context2.next = 24;
                            break;

                        case 23:
                            console.error('Attempted to call doDefaultFetchWithBody without first setting the auth token! Be sure to call setAuthToken() first!');

                        case 24:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2, [[4, 18]]);
        }));

        return function (_x4, _x5) {
            return _ref2.apply(this, arguments);
        };
    }();

    this.authToken = null;
    this.bearerPrefx = null;
};

// Create a StateContainer when fetch-helper is imported. This allows us to expose the internal functions for easier use on the implementing side and keep a single fetch-helper
// StateContainer in memory (ie a singleton StateContainer)


var instance = new StateContainer();

var index = {
    FetchError: FetchError,
    CONTENT_TYPES: CONTENT_TYPES,
    checkStatus: instance.checkStatus,
    doDefaultFetch: instance.doDefaultFetch,
    doDefaultFetchWithBody: instance.doDefaultFetchWithBody,
    setAuthToken: instance.setAuthToken,
    getAuthToken: instance.getAuthToken
};

module.exports = index;
